import { render, staticRenderFns } from "./flexLine.vue?vue&type=template&id=899b71ca&scoped=true"
import script from "./flexLine.vue?vue&type=script&lang=js"
export * from "./flexLine.vue?vue&type=script&lang=js"
import style0 from "./flexLine.vue?vue&type=style&index=0&id=899b71ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b71ca",
  null
  
)

export default component.exports